const initialParams = new URLSearchParams(window.location.search);
const adFirstHandle = initialParams.get('first');

function preserveFirstParameter() {
  if (!adFirstHandle) return;

  const forms = document.querySelectorAll(
    '#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm'
  );

  forms.forEach((form) => {
    let input = form.querySelector('input[name="first"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'first';
      form.appendChild(input);
    }

    input.value = adFirstHandle;
  });
}

async function placeAdProductFirst() {
  if (!adFirstHandle) return;

  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  const escapedHandle = CSS.escape(adFirstHandle);

  const existingProduct = grid.querySelector(
    `[data-product-handle="${escapedHandle}"]`
  );

  if (existingProduct) {
    if (grid.firstElementChild !== existingProduct) {
      grid.prepend(existingProduct);
    }
    return;
  }

  try {
    const response = await fetch(
      `/products/${encodeURIComponent(adFirstHandle)}?section_id=ad-first-product`
    );

    if (!response.ok) return;

    const html = await response.text();

    const template = document.createElement('template');
    template.innerHTML = html.trim();

    const productCard = template.content.querySelector(
      `[data-product-handle="${escapedHandle}"]`
    );

    if (!productCard) return;

    grid.prepend(productCard);
  } catch (error) {
    console.error('Could not load advertised product:', error);
  }
}

function initialiseAdFirstProduct() {
  if (!adFirstHandle) return;

  preserveFirstParameter();
  placeAdProductFirst();

  const collectionContainer = document.querySelector(
    '#ProductGridContainer'
  );

  if (!collectionContainer) return;

  let refreshTimer;

  const observer = new MutationObserver(() => {
    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(() => {
      preserveFirstParameter();
      placeAdProductFirst();
    }, 250);
  });

  observer.observe(collectionContainer, {
    childList: true,
    subtree: true
  });
}

document.addEventListener(
  'DOMContentLoaded',
  initialiseAdFirstProduct
);